module.exports = __webpack_public_path__ + "img/slider-14.57f45beb.jpg";